<template>
  <div class="header">
    <div class="header__background" />
    <div class="header__event-and-present">
      <PinnedEvent v-if="pinnedEvent" v-bind:event="pinnedEvent" v-bind:language="language" />
      <Present />
    </div>
  </div>
</template>

<script>
  import PinnedEvent from '@/components/PinnedEvent';
  import Present from '@/components/Present';

  export default {
    name: 'Header',
    components: {
      Present,
      PinnedEvent,
    },
    props: {
      pinnedEvent: {
        type: Object,
      },
      language: {
        type: String,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  @import '@/styles/functions.scss';

  .header {
    position: relative;
    padding-bottom: 190px;
    
    &__background {
      background: url('/img/timeline/background_768.jpg') no-repeat center;
      background-size: cover !important;
      width: 100%;
      opacity: 0.6;
      height: 553px;
      position: relative;

      &:after {
        content: '';
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 50%;
        bottom: -1px;
        left: 0;
        right: 0;
        background: linear-gradient(to bottom, rgba($baliBlue, 0), rgba($baliBlue, 1) 90%);
      }
    }

    &__event-and-present {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
      gap: 50px;
      position: absolute;
      bottom: 0;
    }

    @include media-breakpoint-up(md) {
      &__background {
        height: 730px;
        background: url('/img/timeline/background_1280.jpg') no-repeat center;
      }

      &__event-and-present {
        padding: 0 26px;
        gap: 67px;
      }
    }

    @include media-breakpoint-up(lg) {
      padding-bottom: 40px;

      &__background {
        height: 730px;
        background: url('/img/timeline/background_1900.jpg') no-repeat center;
      }

      &__event-and-present {
        padding: 0 26px 0 43px;
        flex-direction: row-reverse;
        width: 100%;
        justify-content: space-between;
        align-items: flex-end;

        .pinned-event {
          max-width: 538px;
        }

        .present {
          display: none;
        }
      }
    }

    @include media-breakpoint-up(xl) {
      padding-bottom: 0;
      margin-bottom: -68px;


      &__background {
        height: 980px;
      }

      &__event-and-present {
        .pinned-event {
          margin-bottom: 68px;
        }
      }
    }
  }
</style>
